import SortableTable from '../../components/Table/SortableTable';

const ImportHistoryTable = ( data ) => {
    const columns = [
        {
            property: 'adminName',
            header: 'IMPORTED BY',
            sortable: true,
        },
        {
            property: 'importedDate',
            header: 'DATE',
            sortable: true,
            custom: (value) => {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
        },
        {
            property: 'importedDate',
            header: 'TIME',
            sortable: true,
            custom: (value) => {
                const date = new Date(value + 'Z');
                return date.toLocaleTimeString();
            }
        },
        {
            property: 'locationsAdded',
            header: 'LOCATIONS ADDED',
            sortable: true,
        },
        {
            property: 'locationsUpdated',
            header: 'LOCATIONS UPDATED',
            sortable: true,
        },
        {
            property: 'hasError',
            header: 'STATUS',
            sortable: true,
            custom: (value, row) => {
                if (value && value === true) {
                    return <span className="text-danger">Error</span>;
                }
                else if (row.isComplete !== true) {
                    return `Processing`
                }
                else {
                    return <span className="text-success">Success</span>;
                }
            }
        }
    ]

    return (
        <SortableTable data={data.data} columns={columns} isLoading={data.isLoading} rowStyle={(row) => row.hasError ? "bg-light-red" : ""} />
    )
}

export default ImportHistoryTable;